import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxGeneralMeeting', [
  '$q',
  'ModalService',
  function($q, ModalService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        onbeforesave: '&',
        onaftersave: '&',
        oncancel: '&',
        disabled: '=?',
        relationId: '=',
      },
      template: require('./generalMeeting.html'),
      require: ['ngModel'],
      link: function($scope, element, attrs, ctrl) {
        var ngModel = ctrl[0];
        $scope.showValidation = false;
        $scope.prefix = $scope.$id;
        // ReSharper disable once CoercedEqualsUsing
        $scope.isXeditable = (attrs.xeditable || false) == 'true';
        $scope.isFormOpen = !$scope.isXeditable;
        $scope.saving = false;

        $scope.submit = function(value) {
          if ($scope.saving) return;
          $scope.saving = true;
          return $q
            .when(
              $scope.onbeforesave({
                $data: value,
              }),
            )
            .then(function(result) {
              if (typeof result !== 'undefined' && !!result) {
                if (value.date != null) {
                  if (typeof value.date === 'string')
                    value.date = moment.utc(value.date.substr(0, 10)).toDate();
                }
                ngModel.$setViewValue(value);
                $scope.gm = angular.extend(
                  {
                    type: 0,
                    date: null,
                    week: null,
                    day: null,
                    month: null,
                    fallback: 0,
                    isSaturdayWorkDay: false,
                  },
                  value,
                );
                if ($scope.isXeditable) $scope.isFormOpen = false;
                $scope.onaftersave({
                  $data: value,
                });
                return;
              }
            })
            .finally(function() {
              $scope.saving = false;
            });
        };

        $scope.save = function() {
          if ($scope.gmForm.$invalid) return false;
          var data = angular.copy($scope.gm);
          return $scope.submit(data);
        };

        $scope.undo = function() {
          ngModel.$rollbackViewValue();
          if ($scope.isXeditable) $scope.isFormOpen = false;
          $scope.oncancel();
        };

        $scope.setDateType = function(type) {
          $scope.gm.type = type;
        };

        ngModel.$render = function() {
          $scope.gm = angular.extend(
            {
              type: 0,
              date: null,
              week: null,
              day: null,
              month: null,
              fallback: 0,
              isSaturdayWorkDay: false,
            },
            ngModel.$viewValue,
          );
          if ($scope.gm.fallback === null) $scope.gm.fallback = 0;
          if (!$scope.gm.type) $scope.gm.type = 0;
        };
      },
    };
  },
]);
